export default "__VITE_ASSET__PssXnHF___"